import React from "react";

import { Helmet } from "react-helmet";
import OurNumberSection from "./components/OurNumberSection";
import CompanyStorySection from "./components/CompanyStorySection";
import UbnHeader from "./components/UbnHeader";
import UbnValueSection from "./components/UbnValueSection";
import SiteFooter from "../../components/layout/SiteFooter";

const UtiveBusinessNetwork = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Business NetWork</title>
      </Helmet>

      <UbnHeader />

      <CompanyStorySection />

      {/* <div className="mt-10" id="beAffiliate">
        <SendPulseEmbed
          formId={
            "8fa59558485c98c40a394bcbbe4bd96ceee7c13dcf095883aa603db5f7a288cf"
          }
        />
      </div> */}

      <div className="mt-6">
        <UbnValueSection showImages={false} />
      </div>

      <OurNumberSection />
      <SiteFooter />
    </div>
  );
};

export default UtiveBusinessNetwork;
